import DrivingTestView from "./components/DrivingTestView"

let module = "frontend"

export default [
  {
    path: "view/:id",
    component: DrivingTestView,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
